import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import {
    PowerIcon,
    RelocationJunctionBoxAndCableIcon,
    ModificationPowerCableIcon,
} from "../core/icons/Icons";
import { NumberInput } from "../core/NumberField";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { createStyles, makeStyles, InputLabel } from "@material-ui/core";
import { useCurrentConfiguration } from "../../utils/hooks";

const textStyles = makeStyles(() =>
    createStyles({
        pText: {
            color: Colors.anthracite,
            fontStretch: "normal",
            fontFamily: "innogyWEB",
            fontSize: 22,
            fontWeight: 300,
            fontStyle: "normal",
            lineHeight: 1.27,
            letterSpacing: "normal",
        },
    }),
);

export const ModificationPowerCableRelocationDistanceForm: FC = () => {
    const classes = useStyles();
    const classes2 = textStyles();
    const { values, setValues } = useFormModel<
        ChangeNames.MODIFICATION_POWER_CABLE_RELOCATION_DISTANCE
    >();
    const configuration = useCurrentConfiguration();
    return (
        <div style={{ marginTop: 32 }}>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<PowerIcon />}
                content={
                    <Fragment>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <p
                                className={classes2.pText}
                                style={{ marginTop: 0, marginBottom: 24, flex: 1 }}
                            >
                                Um wieviele Meter soll das Kabel auf dem Privatgrundstück umgelegt
                                werden?
                            </p>
                            {configuration.state.modificationPowerCable?.state.value
                                .cableRelocation ? (
                                <ModificationPowerCableIcon />
                            ) : (
                                <RelocationJunctionBoxAndCableIcon />
                            )}
                        </div>
                        <InputLabel className={classes.labledTextfieldLabel}>Strecke</InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.modificationPowerCableRelocationDistance.value.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.modificationPowerCableRelocationDistance.value.unit}
                            value={
                                values.modificationPowerCableRelocationDistance.value.amount.num ||
                                ""
                            }
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.modificationPowerCableRelocationDistance.value.amount.num =
                                        v.floatValue || null;
                                })
                            }
                            error={values.modificationPowerCableRelocationDistance.error !== null}
                        />
                    </Fragment>
                }
            />
        </div>
    );
};
